module.exports = __webpack_public_path__ + "07_mustache_grey.feaafb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/07_mustache_grey.png
// module id = Wk32
// module chunks = 0